import styled, { css } from 'styled-components';

export const SidebarWrapper = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 999px;
  }
`;

export const Section = styled.section`
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 16px 18px;

  h4 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 12px 0;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .react-select__control {
    min-height: 38px;
    border-radius: 10px;
    border-color: #e2e8f0;
    box-shadow: none;

    &:hover {
      border-color: #cbd5e1;
    }
  }

  .react-select__control--is-focused {
    border-color: #006633 !important;
    box-shadow: 0 0 0 3px rgba(0, 102, 51, 0.1) !important;
  }
`;

type PriorityTone = 'neutral' | 'info' | 'warning' | 'danger';
const PRIORITY_MAP: Record<PriorityTone, string> = {
  neutral: '#94a3b8',
  info: '#3b82f6',
  warning: '#f59e0b',
  danger: '#ef4444',
};

export const PriorityDot = styled.span<{ $tone: PriorityTone }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  ${({ $tone }) => css`
    background: ${PRIORITY_MAP[$tone]};
  `}
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  font-size: 13px;

  & + & {
    border-top: 1px solid #f1f5f9;
  }

  .label {
    color: #64748b;
    font-weight: 500;
  }

  .value {
    color: #0f172a;
    font-weight: 600;
    text-align: right;
  }
`;

export const AssigneeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;

export const AssigneeChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  border-radius: 999px;
  background: #f1f5f9;
  font-size: 12px;
  color: #334155;
  font-weight: 500;
  width: fit-content;

  .avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #006633;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Timeline = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const TimelineItem = styled.li`
  position: relative;
  padding: 0 0 14px 22px;
  font-size: 12.5px;
  color: #334155;

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid #006633;
  }

  &::after {
    content: '';
    position: absolute;
    left: 8.5px;
    top: 16px;
    bottom: -2px;
    width: 1px;
    background: #e2e8f0;
  }

  &:last-child::after {
    display: none;
  }

  .message {
    color: #0f172a;
    font-weight: 600;
    line-height: 1.35;
  }

  .feedback {
    margin-top: 4px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #eef2f7;
    color: #475569;
    font-size: 12px;
    line-height: 1.4;

    strong {
      color: #0f172a;
      font-weight: 700;
    }
  }

  .timestamp {
    margin-top: 4px;
    color: #94a3b8;
    font-size: 11px;
    font-weight: 500;
  }
`;

export const EmptyMini = styled.div`
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  padding: 12px 0;
`;
